export default "__VITE_ASSET__3db87d8c__"